module.exports = __webpack_public_path__ + "media/ringback.aea70a9c.wav";